import { render } from "./MegaMenu.vue?vue&type=template&id=61d9b6fd&scoped=true"
import script from "./MegaMenu.vue?vue&type=script&lang=js"
export * from "./MegaMenu.vue?vue&type=script&lang=js"

import "./MegaMenu.vue?vue&type=style&index=0&id=61d9b6fd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61d9b6fd"]])

export default __exports__